module.exports = __webpack_public_path__ + "assets/img/btn-view-5acc52a8.png";